import { render, staticRenderFns } from "./Hints.vue?vue&type=template&id=528f4ac0&scoped=true"
import script from "./Hints.vue?vue&type=script&lang=js"
export * from "./Hints.vue?vue&type=script&lang=js"
import style0 from "./Hints.vue?vue&type=style&index=0&id=528f4ac0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528f4ac0",
  null
  
)

export default component.exports